module.exports = __webpack_public_path__ + "static/media/picture-(210).61b6ff06.JPG";